const ENCODE_REGEX = new RegExp('[^A-z0-9]', 'g');
const DECODE_REGEX = new RegExp('[+]', 'g');
function encoder(match) {
    if (match === ' ')
        return '+';
    return encodeURIComponent(match);
}
export function encode(value) {
    if (!value)
        return '';
    let encodedString = value.replace(ENCODE_REGEX, encoder);
    return encodedString.replace('(', '%28').replace(')', '%29');
}
export function decode(value) {
    if (!value)
        return '';
    return decodeURIComponent(value.replace(DECODE_REGEX, ' '));
}
